module.exports = '1.6.1';



/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/version.js
 ** module id = 576
 ** module chunks = 9
 **/